import { styled, Typography } from '@healthinal/ui';
import 'animate.css';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/error-handling/ErrorBoundary';
import Footer from './components/Footer';
import { SplashScreen } from './components/SplashScreen';
import { PatientCallcenterMedi24 } from './pages/PatientCallcenterMedi24';

const Wrapper = styled('div')`
  min-height: 100vh;
  display: grid;
  grid-template-rows: 1fr 20px;
`;

export default function App() {
  return (
    <ErrorBoundary isRoot>
      <Suspense fallback={<SplashScreen />}>
        <Wrapper>
          <Routes>
            <Route path="/callcenter/medi24/patient/:patientId" element={<PatientCallcenterMedi24 />} />
            <Route path="*" element={<Fallback />} />
          </Routes>
          <Footer />
        </Wrapper>
      </Suspense>
    </ErrorBoundary>
  );
}

function Fallback() {
  return (
    <Typography>
      In der Callcenter Applikation können nur Patienten auf dem Pfad{' '}
      <code>{'/callcenter/medi24/patient/{patientId}'}</code> geladen werden.
    </Typography>
  );
}
